import {createApp} from 'vue'
import router from './routes'
import store from "./store";
import ppJs from './catalog'
import Pubcatalog from "./Pubcatalog";

let pubcatalog = createApp(Pubcatalog)
pubcatalog.config.globalProperties.ppJs = ppJs
pubcatalog.use(router)
pubcatalog.use(store)

pubcatalog.mount('#pubcatalog')

window.url_helpers = {
    get: (key) => {
        let params = new URLSearchParams(document.location.search.substring(1));
        if (params.has(key)) {
            return params.get(key)
        } else {
            return null
        }
    },
    set_viewtype: (viewtype) => {
        let url = new URL(document.location.href)
        url.searchParams.set('viewtype', viewtype)
        history.pushState(null, null, url.toString());
    },
    get_viewtype: () => {
        return window.url_helpers.get("viewtype")
    },
    set_page: (page) => {
        let url = new URL(document.location.href)
        url.searchParams.set('page', page)
        history.pushState(null, null, url.toString());
    },
    get_page: () => {
        return window.url_helpers.get("page")
    },

    set_sort: (sort) => {
        let url = new URL(document.location.href)
        url.searchParams.set('sort', sort)
        history.pushState(null, null, url.toString());
    },
    get_sort: () => {
        return window.url_helpers.get("sort")
    },

    set_search: (search) => {
        let url = new URL(document.location.href)

        if (search.length == 0) {
            url.searchParams.delete('search')
        } else {
            url.searchParams.set('search', search)
        }
        history.pushState(null, null, url.toString());
    },
    get_search: () => {
        return window.url_helpers.get("search")
    },

    set_min_price: (min_price) => {
        let url = new URL(document.location.href)
        min_price = parseFloat(min_price)
        if (min_price == 0) {
            url.searchParams.delete('min_price')
        } else {
            url.searchParams.set('min_price', min_price)
        }
        history.pushState(null, null, url.toString());
    },
    get_min_price: () => {
        if (window.url_helpers.get("min_price")) {
            return parseFloat(window.url_helpers.get("min_price"))
        } else {
            return null
        }
    },

    set_max_price: (max_price) => {
        let url = new URL(document.location.href)
        max_price = parseFloat(max_price)
        if (max_price == 0) {
            url.searchParams.delete('max_price')
        } else {
            url.searchParams.set('max_price', max_price)
        }
        history.pushState(null, null, url.toString());
    },
    get_max_price: () => {
        if (window.url_helpers.get("max_price")) {
            return parseFloat(window.url_helpers.get("max_price"))
        } else {
            return null
        }
    },

    set_filter_by_type: (slug, enum_id, add = true) => {
        let url = new URL(document.location.href)
        let param = url.searchParams.getAll(slug)

        if (param.length == 0 && add) {
            url.searchParams.set(slug, enum_id)
        }

        if (param.length > 0) {
            let enum_ids = param[0].split('-').filter(el => {
                return el != "" && el != enum_id
            })
            if (add)
                enum_ids.push(enum_id)

            if (enum_ids.length) {
                url.searchParams.set(slug, enum_ids.join('-'))
            } else {
                url.searchParams.delete(slug)
            }
        }
        history.pushState(null, null, url.toString());


    },
}

window.onload = function() {
    ppJs.popup_catalog.init()
}

window.keyboard_replacer = {
    d: {
        "q": "й", "w": "ц", "e": "у", "r": "к", "t": "е", "y": "н", "u": "г",
        "i": "ш", "o": "щ", "p": "з", "[": "х", "]": "ъ", "a": "ф", "s": "ы",
        "d": "в", "f": "а", "g": "п", "h": "р", "j": "о", "k": "л", "l": "д",
        ";": "ж", "'": "э", "z": "я", "x": "ч", "c": "с", "v": "м", "b": "и",
        "n": "т", "m": "ь", ",": "б", ".": "ю", "/": ".", ">": "Ю", "?": ".",
        "<": "Б"
    },
    q: {
        "й": "q", "ц": "w", "у": "e", "к": "r", "е": "t", "н": "y", "г": "u",
        "ш": "i", "щ": "o", "з": "p", "х": "[", "ъ": "]", "ф": "a", "ы": "s",
        "в": "d", "а": "f", "п": "g", "р": "h", "о": "j", "л": "k", "д": "l",
        "ж": ";", "э": "'", "я": "z", "ч": "x", "с": "c", "м": "v", "и": "b",
        "т": "n", "ь": "m", "б": ",", "ю": "."
    },
    reverse_q(text){
        if (text == "")
            return ""
        let new_text = ""
        for (const c of text) {
            new_text += window.keyboard_replacer.q[c]
        }

        return new_text
    },
    reverse(text){
        if (text == "")
            return ""
        let new_text = ""
        for (const c of text) {
            new_text += window.keyboard_replacer.d[c]
        }

        return new_text
    },
}
